import { render } from "./UserApproval.vue?vue&type=template&id=74c07900&scoped=true&ts=true"
import script from "./UserApproval.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserApproval.vue?vue&type=script&setup=true&lang=ts"

import "./UserApproval.vue?vue&type=style&index=0&id=74c07900&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c07900"],['__file',"src/components/scan/admin/UserApproval.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74c07900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74c07900', __exports__)) {
    console.log('reload')
    api.reload('74c07900', __exports__)
  }
  
  module.hot.accept("./UserApproval.vue?vue&type=template&id=74c07900&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('74c07900', render)
  })

}


export default __exports__